export const MIN_SEGUNDOS_EXIBICAO = 3;

/** Chave `${campanha_id}|${dia}`. */
export type BufferExibicoes = Record<string, { campanha_id: string; dia: string; exibicoes: number; segundos: number }>;

/** Soma um trecho já fechado. Menos de 1 s não altera o buffer; a exibição só conta com 3 s ou mais. */
export function somarExibicao(buf: BufferExibicoes, campanhaId: string, dia: string, segundos: number): BufferExibicoes {
  const inteiro = Math.floor(segundos);
  if (inteiro < 1) return buf;
  const chave = `${campanhaId}|${dia}`;
  const atual = buf[chave] ?? { campanha_id: campanhaId, dia, exibicoes: 0, segundos: 0 };
  return {
    ...buf,
    [chave]: {
      campanha_id: campanhaId,
      dia,
      exibicoes: atual.exibicoes + (inteiro >= MIN_SEGUNDOS_EXIBICAO ? 1 : 0),
      segundos: atual.segundos + inteiro,
    },
  };
}
